module.exports = __webpack_public_path__ + "static/media/custom-15000-low.b3c6f43a.svg";